import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import cn from "classnames";
import { withRouter } from "react-router";

import { submitLoginForm, clearErrors } from "../actions/webInterface";
import Validator from "../helpers/validation";

const schema = [
  {
    name: "email",
    fieldName: "Логин",
    rules: "required"
  },
  {
    name: "password",
    fieldName: "Пароль",
    rules: "required"
  }
];

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: "",
      password: "",
      submitErrors: [],
      serverError: null
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentWillMount() {
    const { redirectPath, history, loggedIn } = this.props;

    if (loggedIn) {
      history.push(redirectPath);
    }
  }

  componentDidMount() {
    this.validator = new Validator(this.form, schema);
  }

  onSubmit(e) {
    e.preventDefault();

    const validation = this.validator.validateForm();

    if (validation.valid) {
      this.props.submitLoginForm(
        { email: this.state.login, password: this.state.password },
        () => {
          this.props.history.push(this.props.redirectPath);
        }
      );
    } else {
      this.setState({
        submitErrors: validation.errors
      });
    }
  }

  onInputChange(e, key) {
    this.validator.clearFieldsErrors();
    this.props.clearErrors();
    this.setState({
      [key]: e.target.value,
      submitErrors: []
    });
  }

  render() {
    return (
      <div className="login-form">
        <h1 className="login-form__title">Необходима авторизация.</h1>
        <form
          action=""
          method=""
          className="col-xs-4 col-lg-3 custom-form"
          ref={c => (this.form = c)}
        >
          {this.state.submitErrors.length || this.props.serverError ? (
            <div className="alert alert-danger" role="alert">
              {this.state.submitErrors.map((error, key) => (
                <div key={`error_${key}`}>{error}</div>
              ))}
              {this.props.serverError}
            </div>
          ) : null}
          <div className="form-group">
            <label className="custom-form__label">Логин</label>
            <input
              type="text"
              className={cn("custom-form__input")}
              value={this.state.login}
              onChange={e => this.onInputChange(e, "login")}
              name="email"
            />
          </div>
          <div className="form-group">
            <label className="custom-form__label">Пароль</label>
            <input
              type="password"
              className={cn("custom-form__input")}
              value={this.state.password}
              onChange={e => this.onInputChange(e, "password")}
              name="password"
            />
          </div>
          <button
            type="submit"
            className="btn btn-success col-xs-6"
            onClick={this.onSubmit}
          >
            Войти
          </button>
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  submitLoginForm: PropTypes.func.isRequired,
  serverError: PropTypes.string,
  clearErrors: PropTypes.func.isRequired,
  history: PropTypes.object,
  redirectPath: PropTypes.string,
  loggedIn: PropTypes.bool
};

const mapStateToProps = state => ({
  serverError: state.webInterface.error,
  loggedIn: !!state.webInterface.authToken
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitLoginForm,
      clearErrors
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginForm)
);



// WEBPACK FOOTER //
// ./containers/LoginForm.js